import type { ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { queryClient } from './client';

type ReactQueryProviderProps = {
    children: ReactNode;
};

export function ReactQueryProvider({ children }: ReactQueryProviderProps) {
    return (
        <QueryClientProvider client={queryClient}>
            {children}
            {process.env.NODE_ENV === 'development' ? (
                <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
            ) : null}
        </QueryClientProvider>
    );
}
